import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const ParentType = iotsUtils.fromList(constants.folder.parentTypes);
